<template>
  <mobile-selection v-if="isMobile" />
  <desktop-selection v-else />
</template>

<script>
  import { isMobile } from 'mobile-device-detect'
  import MobileSelection from '../../mobile/selection/Selection'
  import DesktopSelection from '../../desktop/selection/Selection'

  export default {
    name: 'common-selection',
    components: {
      'mobile-selection': MobileSelection,
      'desktop-selection': DesktopSelection
    },
    data () {
      return {
        isMobile
      }
    }
  }
</script>
